// Tech Rescue Lab – theme.js
// Sticky header shadow
window.addEventListener('scroll', function () {
  var h = document.querySelector('.trl-header');
  if (h) {
    h.style.boxShadow = window.scrollY > 8
      ? '0 4px 30px rgba(0,0,0,0.6)'
      : 'none';
  }
});

// Cart count update via AJAX
document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var el = document.querySelector('.trl-cart-count');
      if (el) el.textContent = cart.item_count;
    })
    .catch(function () {});
});
